<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('multisend.title', 'Загальні розсилки') }}</h1>
        </div>
        <div class="button-holder  mb-2">
          <button class=" default-btn btn-accent btn-with-icon" @click="createPost">
            <span class="text">{{ $static('multisend.add', 'Додати розсилку') }}</span>
            <span class="icon icon-add"></span>
          </button>
        </div>

        <div class="table-wrapper">
          <div class="table-responsive">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th>№</th>
                  <th>{{ $static('multisend.t1', 'Ім\я') }}</th>
                  <th class="text-center">{{ $static('multisend.t2', 'Статус') }}</th>
                  <th>{{ $static('multisend.t3', 'Всього передплатників') }}</th>
                  <th>{{ $static('multisend.t4', 'Надіслано/доставлено') }}</th>
                  <th>{{ $static('multisend.t5_1', 'Успішність') }}</th>
                  <th>{{ $static('multisend.t6', 'Дата створення') }}</th>
                  <th>{{ $static('multisend.t7', 'Надіслати') }}</th>
                  <th>{{ $static('multisend.t8', 'Редагувати') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(send, index) in items" :key="index">
                  <th scope="row">{{ send.id }}</th>
                  <td>
                    <div class="text">{{ send.name }}</div>
                  </td>
                  <td class="label-td pr-0 text-center ">
                    <div class="label-status" :class="getStatus(send.status)">{{ send.status }}</div>
                  </td>

                  <td>{{ getTotal(send) }}</td>
                  <td><b>{{ getSend(send) }}</b> / {{ getSuccess(send) }}</td>
                  <td>{{ getReady(send) }} %</td>

                  <td>{{ send.created_at.toLocaleString(currentLang) }}</td>
                  <td>
                    <template v-if="isEditable(send.status)">
                      <button class="btn-icon btn-rounded btn-icon-transparent" v-if="send.status != 'start'"
                        @click="setStatus(send, 'start')">
                        <span class="icon-2 icon-2play"></span>
                      </button>
                      <button class="btn-icon btn-rounded btn-icon-transparent" v-else-if="send.status == 'start'"
                        @click="setStatus(send, 'stop')">
                        <span class="icon-2 icon-2pause"></span>
                      </button>
                    </template>
                  </td>
                  <td style="display: flex">
                    <button class="btn-icon btn-rounded btn-icon-transparent inline-block"
                      :title="$static('common.edit', 'Редагувати')" @click="openPost(send)" v-if="isEditableBody(send)">
                      <span class="icon icon-edit"></span>
                    </button>
                    <button class="btn-icon btn-rounded btn-icon-transparent inline-block"
                      :title="$static('common.copy', 'Зробити копію')" @click="copyPost(send)" v-else>
                      <span class="icon icon-edit"></span>
                    </button>
                    <button v-if="send.status !== 'progress' && send.status !== 'start'"
                      :title="$static('common.delete', 'Видалити')"
                      class="btn-icon btn-rounded btn-icon-transparent inline-block" @click="deletePost(send)">
                      <span class="icon icon-trash"></span>
                    </button>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="pagination-panel table-pagination" v-if="pages.length > 1">
          <nav>
            <router-link :to="{ name: 'Multisend', params: { page: Math.max(pageIndex - 1, 1) } }"
              class="previous extreme" :class="{ 'disabled': pageIndex < 2 }">
              <span class="icons icon-left"></span>
            </router-link>
            <ul class="pagination pagination-list">
              <li v-for="(page, index) in pages" :key="index" :class="{ 'active': pageIndex === page }">
                <router-link :to="{ name: 'Multisend', params: { page: page } }">{{ page }}</router-link>
              </li>
            </ul>
            <router-link :to="{ name: 'Multisend', params: { page: Math.min(pageIndex + 1, pageAmount) } }"
              class="end extreme" :class="{ 'disabled': pageIndex > pageAmount - 1 }">
              <span class="icons icon-right"></span>
            </router-link>
          </nav>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

const pageSlotsAmount = 5;

export default {
  name: 'Multisend',
  props: ['page'],
  data() {
    return {
      filter: {
        page: 1,
        perPage: 10,
        search: undefined,
        status: []
      },
      changeStatus: false,
      sortBy: 'time',
      items: [],
      total: 0,
      checkUpdate: undefined
    }
  },
  mounted() {
    if (this.page) {
      this.filter.page = parseInt(this.page)
    }
    this.getItems();
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.filter.perPage)
    },
    pages() {
      if (this.pageAmount < pageSlotsAmount) return [...Array(this.pageAmount).keys()].map(x => x + 1);

      let min = Math.max(this.pageIndex - (pageSlotsAmount - 1) / 2, 1);
      if (this.pageIndex + 1 >= this.pageAmount) {
        min = this.pageAmount - 4;
      }
      let result = [...Array(pageSlotsAmount).keys()].map(x => x + min);
      result[0] = 1;
      result[pageSlotsAmount - 1] = this.pageAmount;

      return result;
    },
    pageAmount() {
      return Math.max(Math.ceil(this.total / this.filter.perPage), 1);
    },
    pageIndex() {
      return (this.page && Number.isInteger(+this.page)) ? +this.page : 1;
    },
    currentLang() {
      const currentLang = localStorage.getItem('$lang');
      console.log(currentLang)
      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    }
  },
  methods: {
    isEditableBody(send) {
      return ['new', 'stop'].indexOf(send.status) > -1 && send.info?.ready < 1
    },
    createPost() {
      if (this.total === 100) {
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('multisend.max-error', 'Досягнуто максимальну кількість створених розсилок'),
          type: 'error',
          duration: 3000
        });
        return
      }

      this.$router.push({ name: 'PostEdit' })
    },
    openPost(send) {
      this.$router.push({ name: 'PostEdit', params: { 'id': send.id } })
    },
    copyPost(send) {
      this.$router.push({ name: 'CopyPostEdit', params: { 'copy': send.id } })
    },
    getStatus(status) {
      switch (status) {
        case 'new':
          return 'label-new';
        case 'ready':
          return 'label-done';
        case 'start':
          return 'label-launch';
        case 'progress':
          return 'label-proccess';
        case 'stop':
          return 'label-stop';
      }
    },
    getTotal(send) {
      return send && send.info && send.info.total ? send.info.total : 0
    },
    getReady(send) {
      let ready = this.getSend(send);
      let success = this.getSuccess(send);
      return ready > 0 && success > 0 ? (success / ready * 100) | 0 : 0
    },
    getSend(send) {
      return send && send.info && send.info.ready ? send.info.ready : 0
    },
    getSuccess(send) {
      return send && send.info && send.info.success ? send.info.success : 0
    },
    isEditable(status) {
      return ['new', 'stop', 'start', 'progress'].indexOf(status) > -1
    },
    isUpdatable(status) {
      return ['start', 'progress'].indexOf(status) > -1
    },
    async deletePost(send) {
      if (send.status === 'progress' || send.status === 'start') return;

      try {
        if (send.id) {
          const response = await api.delete('/api/multisend/' + send.id);
          console.log(response)
          if (response.data.error) {
            throw new Error();
          }

          await this.getItems();

          this.$notify({
            title: this.$static('notify.multisend-title', 'Розсилка'),
            text: this.$static('notify.remove-ms-success', 'Розсилку видалено'),
            duration: 3000
          });
        }
      } catch (error) {
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('notify.remove-ms-error', 'Сталася помилка при видаленні розсилки'),
          type: 'error',
          duration: 3000
        });
      }
    },
    setStatus(send, status) {
      api.put('/api/multisend', Object.assign(send, { status: status })).then(() => {
        this.changeStatus = true;
        if (send.status === 'start') {
          this.$notify({
            title: send.name,
            text: status,
            type: 'info',
            duration: 3000
          });
        } else if (send.status === 'stop') {
          this.$notify({
            title: send.name,
            text: status,
            type: 'warn',
            duration: 3000
          });
        } else {
          this.$notify({
            title: send.name,
            text: status,
            duration: 3000
          });

        }

        this.getItems()
      })
    },
    getItems() {
      let filer = Object.assign({}, this.filter);
      return api.post('/api/multisend', { filter: filer, sortBy: this.sortBy }).then(response => response.data).then(
        data => {
          this.items = data.result.map(i => {
            i.created_at = new Date(i.created_at);
            i.updated_at = new Date(i.updated_at);
            return i
          });
          this.filter.page = data.page;
          this.total = data.total;

          let proggressed = this.items.some(x => this.isUpdatable(x.status));
          if (!proggressed) {
            if (this.checkUpdate) {
              clearInterval(this.checkUpdate);
              this.checkUpdate = undefined;
              if (!this.changeStatus) {
                this.changeStatus = false;
                this.$notify({
                  title: this.$static('nav.t87', 'Розсилки'),
                  text: 'complete',
                  duration: 3000
                });
              }
            }
          } else if (this.checkUpdate === undefined) {
            this.checkUpdate = setInterval(this.getItems, 2000)
          }

        })
    }
  },
  beforeUnmount() {
    clearInterval(this.checkUpdate);
  },
  watch: {
    page(val) {
      this.filter.page = val;
      this.getItems()
    }
  }
}
</script>

<style scoped></style>